import PlaceholderPage from "../components/PlaceholderPage";

function BrochuresPage() {
  return (
    <PlaceholderPage
      title="Brochures"
      description="Downloadable product and service brochures are coming soon."
      path="/resources/brochures"
    />
  );
}

export default BrochuresPage;
